import styled from 'styled-components'

import { FilledInfoIcon, LabelInfoIcon } from './svgIcons'
import type { TooltipProps } from './Tooltips'
import { Tooltip } from './Tooltips'

const BlueInfoIcon = styled(FilledInfoIcon)`
  color: ${({ theme }) => theme.colors.blue[40]};
`

export const StyledLabelInfoIcon = styled(LabelInfoIcon)`
  color: ${({ theme }) => theme.colors.field.label};
  display: block;
  /* geometrically centred already, but the glyph's own weighting reads low without this */
  margin-bottom: 2px;
`

const IconWrapperSpan = styled.span`
  display: inline-flex;
  align-items: center;
  vertical-align: middle;

  & > span {
    display: inline-flex;
    align-items: center;
  }
`

export function BlueInfoIconWithTooltip(props: Omit<TooltipProps, 'children' | 'withPortal'>) {
  return (
    <Tooltip {...props} withPortal>
      <IconWrapperSpan>
        <BlueInfoIcon size={16} />
      </IconWrapperSpan>
    </Tooltip>
  )
}

export function LabelInfoIconWithTooltip({ title }: Pick<TooltipProps, 'title'>) {
  return (
    <Tooltip title={title} placement="top" withPortal>
      <IconWrapperSpan>
        <StyledLabelInfoIcon size={16} />
      </IconWrapperSpan>
    </Tooltip>
  )
}
